export const DCMA_COMPLIANCE = {
  DCMA_STATUS_PANEL_TOOLTIP: 'dcma-status-panel-tooltip',
  DCMA_LEARN_MORE_LINK: 'dcma-learn-more-link',
  DCMA_DOWNLOAD_EXCEL_BUTTON: 'dcma-download-excel-button',
  DCMA_STOP_COMPARISON_BUTTON: 'dcma-stop-comparison-button',
  DCMA_STATUS_TABLE_TOOLTIP: 'dcma-status-table-tooltip',
  DCMA_INSPECT_ELEMENTS_BUTTON: 'dcma-inspect-elements-button',
  DCMA_SET_FILTER_DIALOG: 'dcma-set-filter-dialog',
  DCMA_SET_FILTER_CLOSE_BUTTON: 'dcma-set-filter-close-button',
  DCMA_SET_FILTER_CANCEL_BUTTON: 'dcma-set-filter-cancel-button',
  DCMA_SET_FILTER_OPEN_TABLE_BUTTON: 'dcma-set-filter-open-table-button',
  DCMA_SET_FILTER_OPEN_CANVAS_BUTTON: 'dcma-set-filter-open-canvas-button',
  DCMA_LEARN_MORE_EXTERNAL_LINK: 'dcma-learn-more-external-link',
  DCMA_RUN_QUALITY_CHECK_BUTTON: 'dcma-run-quality-check-button'
} as const;
